import React from "react";

// ui
import { CustomInput } from "reactstrap";

const CheckBox = (props) => {
	const {
		currentValue,
		error,
		name,
		label,
		required,
		touched,
		value,
		...attributes
	} = props;

	const inputId = `checkbox-${name.replace(/\./g, "-")}`;
	const valid = required && touched && !error ? true : false;
	const invalid = required && touched && error ? true : false;

	return (
		<CustomInput
			name={name}
			id={inputId}
			label={label}
			checked={currentValue === value}
			valid={valid}
			invalid={invalid}
			value={value}
			type="checkbox"
			{...attributes}
		/>
	);
};

CheckBox.defaultProps = {
	required: false,
	value: true
};

export default CheckBox;
